import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "system", font: "system", setTheme: () => {}, setFont: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("niyant-theme") || "system");
  const [font, setFont] = useState(() => localStorage.getItem("niyant-font") || "system");

  useEffect(() => {
    const root = document.documentElement;
    const applyTheme = (resolved) => {
      if (resolved === "dark") {
        root.classList.add("dark");
      } else {
        root.classList.remove("dark");
      }
    };

    if (theme === "system") {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      applyTheme(mq.matches ? "dark" : "light");
      const handler = (e) => applyTheme(e.matches ? "dark" : "light");
      mq.addEventListener("change", handler);
      return () => mq.removeEventListener("change", handler);
    } else {
      applyTheme(theme);
    }
  }, [theme]);

  useEffect(() => {
    document.body.setAttribute("data-font", font);
  }, [font]);

  const updateTheme = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem("niyant-theme", newTheme);
  };

  const updateFont = (newFont) => {
    setFont(newFont);
    localStorage.setItem("niyant-font", newFont);
  };

  return (
    <ThemeContext.Provider value={{ theme, font, setTheme: updateTheme, setFont: updateFont }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
